import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-hazards-importer',
  templateUrl: './hazards-importer.component.html',
  styleUrls: ['./hazards-importer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HazardsImporterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
